import React from 'react';

// Map reaction types to emojis and colors (matching your system's actual reaction types)
const REACTION_CONFIG = {
  like: { emoji: '❤️', color: '#EF4444', bgColor: '#FEF2F2', label: 'Like' },
  funny: { emoji: '😂', color: '#10B981', bgColor: '#F0FDF4', label: 'Funny' },
  angry: { emoji: '😡', color: '#DC2626', bgColor: '#FEF2F2', label: 'Angry' },
  sad: { emoji: '😢', color: '#6B7280', bgColor: '#F9FAFB', label: 'Sad' },
  innovative: { emoji: '💡', color: '#F59E0B', bgColor: '#FFFBEB', label: 'Insightful' },
  big_brain: { emoji: '🧠', color: '#8B5CF6', bgColor: '#F5F3FF', label: 'Big Brain' },
  need_source: { emoji: '📚', color: '#DC2626', bgColor: '#FEF2F2', label: 'Needs Source' },
  poor_logic: { emoji: '🧩', color: '#6B7280', bgColor: '#F9FAFB', label: 'Poor Logic' }
};

const ReactionBadge = ({
  primaryReactionType,
  reactionSummary = {},
  totalReactions = 0,
  size = 'sm',
  showTooltip = true
}) => {
  if (!primaryReactionType || !REACTION_CONFIG[primaryReactionType]) {
    return null;
  }

  const config = REACTION_CONFIG[primaryReactionType];
  const isLarge = size === 'lg';

  return (
    <div className="relative group">
      <div
        className={`
          inline-flex items-center gap-1 px-2 py-1 rounded-full 
          border transition-all duration-200 cursor-default
          ${isLarge ? 'text-sm' : 'text-xs'}
        `}
        style={{
          backgroundColor: config.bgColor,
          borderColor: config.color + '40',
          color: config.color
        }}
      >
        <span className={isLarge ? 'text-base' : 'text-sm'}>{config.emoji}</span>
        <span className="font-semibold">
          {totalReactions > 1 ? `${totalReactions} reactions` : config.label}
        </span>
      </div>

      {showTooltip && Object.keys(reactionSummary).length > 1 && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
          <div className="flex flex-col gap-1">
            {Object.entries(reactionSummary)
              .sort(([, a], [, b]) => b - a)
              .map(([reactionType, count]) => {
                const reactionConfig = REACTION_CONFIG[reactionType];
                return reactionConfig ? (
                  <div key={reactionType} className="flex items-center gap-2 justify-between">
                    <span className="flex items-center gap-1">
                      <span>{reactionConfig.emoji}</span>
                      <span>{reactionConfig.label}</span>
                    </span>
                    <span className="font-semibold">{count}</span>
                  </div>
                ) : null;
              })}
          </div>
          {/* Tooltip arrow */}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
        </div>
      )}
    </div>
  );
};

export default ReactionBadge;
